import { Form } from 'src/app/models/form.model';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Component } from "@angular/core";
import { UserService } from 'src/app/services/user.service';
import * as FormActions from '../../reducers/actions/forms.actions';
import * as FinalFormactions from '../../reducers/actions/form_final.actions';
import { SidenavService } from 'src/app/services/sidenav.service';
import { GLOBAL } from 'src/app/services/global';
import { FinalForm } from 'src/app/models/final_form.model';


interface AppState {
  form: Form;
}
interface AppStateFinalForm {
  formFinal: FinalForm
}
@Component({
  selector: "page-instructions",
  templateUrl: "./instructions.component.html",
  styleUrls: ["./instructions.component.css"],
  providers: [UserService]
})
export class InstructionsComponent {

  
  public identity;
  public token;
  public active;
  public imgSrc = "assets/permisos/document.svg";
  public forms = [];
  public materias: any = [];
  public existForm;
  public numberForm;
  public iconosPermisos = ["assets/permisos/obramenor.svg", "assets/permisos/edificacion.svg", "assets/permisos/houses.svg",
    "assets/permisos/parquet.svg", "assets/permisos/profiles.svg", "assets/permisos/landslide.svg", "assets/permisos/antenna.svg",
    "assets/permisos/worker.svg", "assets/permisos/fire-station.svg"]
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService,
    private store: Store<AppState>,
    private _sidenavService: SidenavService,
    private storeF: Store<AppStateFinalForm>
  ) {
    // this.getFormUsed();  
    this.getFormularios();
  }

  ngOnInit() {
    if (!sessionStorage.getItem('identity-domCloud') || !sessionStorage.getItem('token-domCloud')) {
      this._router.navigate(['/']);

    }

    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    if (localStorage.getItem("form")) {
      this.active = false
    } else {
      this.active = true
    }


  }

  /*  getForm(id, title) {
     localStorage.clear();
     sessionStorage.removeItem('borrador');
     this.store.dispatch(new FormActions.FormUpdate(id, title))
     localStorage.setItem("form", id)
 
 
   } */

  ngDoCheck() {

    this.numberForm = localStorage.getItem("form")
    if (localStorage.getItem("form")) {
      this.existForm = true;

    } else {
      this.existForm = false;
    }
  }

  getFormUsed() {
    this._userService.getFormUser().subscribe(
      response => {
        this.forms = response;
      },
      error => {
        console.log(error)
      }
    )
  }

  openForms(num) {
    this._sidenavService.toggle();
    sessionStorage.setItem("expandedItem", num)
  }
  getFormularios() {
    this._userService.getFormularios().subscribe(
      (response) => {


        this.materias = response.materias;
        // console.log("response", response.materias)
        // console.log("response.materias[0].name", response.materias[0].name)
      },
      error => {
        console.log("main-nav.component.ts error", error)
      });
  }
  getForm(id?, title?, online?) {
    console.log(id, title, online)

    if (online) {

      localStorage.clear();
      sessionStorage.removeItem('borrador');
      this.store.dispatch(new FormActions.FormUpdate(id, title))
      this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
        newFormValues: {
          formulario: '1.1',
          tipo_solicitud: 'prueba',
        }
      }))

      setTimeout(() => {
        this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
          newFormValues: {
            proyectos: []
          }
        }))
      }, 2000)
      localStorage.setItem("form", id)
      this._userService.formMostUsed(id, title).subscribe(
        response => {
          console.log(response)
        },
        error => {
          console.log(error)
        }
      )
    }
    else {
      alert("El formulario seleccionado solo se puede realizar presencialmente")
    }

  }

}